import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiverso = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 17" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-17",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsx("polygon", {
				id: "\\u2260",
				fill: "#424548",
				fillRule: "nonzero",
				points: "460.888889 622.888889 487.388889 572.888889 621.888889 572.888889 621.888889 538.888889 505.888889 538.888889 540.388889 472.888889 621.888889 472.888889 621.888889 438.888889 558.888889 438.888889 585.888889 388.888889 549.888889 388.888889 523.388889 438.888889 388.888889 438.888889 388.888889 472.888889 504.888889 472.888889 470.388889 538.888889 388.888889 538.888889 388.888889 572.888889 451.888889 572.888889 424.888889 622.888889"
			})]
		})
	})]
});
export default SvgDiverso;
